module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-check-a3520a11.svg";